// Section 18: Retirement age policy. Elders past it are not auto-assigned; raising it costs trust -3.
// Default: config.policies.defaults.retirementAge.
import type { Config } from '../../config';
import { noProblem } from '../../core/content-helpers';
import { isElder, peopleSorted } from '../../core/queries';
import { definePolicy, noModifiers } from '../../core/registry';

export function retirementAge(config: Config) {
  const rank = (age: 55 | 60 | 65 | 'never'): number =>
    age === 'never' ? Number.MAX_SAFE_INTEGER : age;

  return definePolicy({
    id: 'retirementAge',
    label: 'Retirement age',
    section: 'S18',
    group: 'work',
    options: [55, 60, 65, 'never'],
    default: config.policies.defaults.retirementAge,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: (from, to) => (rank(to) > rank(from) ? config.policies.retirementRaisedTrust : 0),
    affects(ctx, option) {
      if (option === 'never') {
        const people = peopleSorted(ctx.state).filter((p) => isElder(config, p)).length;
        return [{ key: 'policy.retirement.never', params: { people } }];
      }
      const at = option * config.people.seasonsPerYear;
      const people = peopleSorted(ctx.state).filter((p) => p.ageSeasons >= at).length;
      return [{ key: 'policy.retirement.retired', params: { people, age: option } }];
    },
    validate: noProblem,
  });
}
